module.exports = __webpack_public_path__ + "static/media/wgpocpl_128.37812197.ico";